export const MULTI_OPTION_SEPARATOR = ':'
